import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { DeviceDetectorService } from "ngx-device-detector";
import { Subscription } from "rxjs";
import { IConfiguration } from "src/app/_models/configuration/IConfiguration";
import { ConfigurationService } from "src/app/_services/configuration.service";

@Component({
  selector: "app-landing-footer",
  templateUrl: "./landing-footer.component.html",
  styleUrls: ["./landing-footer.component.scss"],
})
export class LandingFooterComponent implements OnInit {
  subscriptions = new Subscription();
  isIEBrowser = false;
  year = moment().format("YYYY");
  configurations: IConfiguration[] = [];
  aboutProject: string;
  utilLinks: string;

  constructor(
    private device: DeviceDetectorService,
    private configurationService: ConfigurationService
  ) { }

  ngOnInit() {
    this.isIEBrowser = this.device.browser.toLocaleLowerCase() === 'ie';

    this.getConfigurations();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private getConfigurations() {
    const sub = this.configurationService.getConfigurations(true).subscribe(
      (res: IConfiguration[]) => {
        this.configurations = res;

        this.setElements();
      });
    this.subscriptions.add(sub);
  }

  private setElements() {
    let aboutProjectLocal = this.configurations.find(x => x.key === 'aboutProject');
    if (aboutProjectLocal) {
      this.aboutProject = aboutProjectLocal.value;
    }

    let aboutPortalLocal = this.configurations.find(x => x.key === 'utilLinks');
    if (aboutPortalLocal) {
      this.utilLinks = aboutPortalLocal.value;
    }
  }
}
